const getVideos = async (playlistID) => {
  const result = [];
  let pageToken;
  do {
    const params = new URLSearchParams({
      part: "snippet",
      key: process.env.REACT_APP_YOUTUBE || "",
      maxResults: "50",
      playlistId: playlistID,
    });
    if (pageToken) params.set("pageToken", pageToken);
    const response = await fetch(
      `https://www.googleapis.com/youtube/v3/playlistItems?${params}`,
    );
    const data = await response.json();
    if (!response.ok || !Array.isArray(data.items))
      throw new Error("Unable to load playlist");
    result.push(...data.items);
    pageToken = data.nextPageToken;
  } while (pageToken);
  return result;
};
export default getVideos;
